"use client";

import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import UsedCarSeoSection from "./UsedCarSeoSection";
import styles from "./UsedCarSeoShared.module.scss";
import { UsedCarSeoCitiesSectionProps } from "./UsedCarSeoShared.types";
import { useGlobalLoader } from "@hooks/useGlobalLoader";

export default function UsedCarSeoCitiesSection({
  title,
  items,
}: UsedCarSeoCitiesSectionProps) {
  const { showLoader } = useGlobalLoader();
  const citySplitIndex = Math.ceil(items.length / 2);
  const cityColumns = [
    items.slice(0, citySplitIndex),
    items.slice(citySplitIndex),
  ].filter((column) => column.length > 0);

  return (
    <UsedCarSeoSection deferred>
      <h2 className={styles.citiesSectionTitle}>{title}</h2>
      <div className={styles.mobileCityList}>
        {items.map((city, cityIndex) => (
          <a
            key={`${city.label}-mobile-${cityIndex}`}
            href={city.href}
            className={styles.cityLink}
            onClick={() => showLoader()}
          >
            <span>{city.label}</span>
            <Image
              src={`${assetLoader()}/icons/chevron_right_dark.svg`}
              alt="right arrow"
              width={20}
              height={20}
              className={styles.cityArrow}
            />
          </a>
        ))}
      </div>
      <div className={styles.cityColumns}>
        {cityColumns.map((column, columnIndex) => (
          <div key={`city-column-${columnIndex}`} className={styles.cityColumn}>
            {column.map((city, cityIndex) => (
              <a
                key={`${city.label}-${cityIndex}`}
                href={city.href}
                className={styles.cityLink}
                onClick={() => showLoader()}
              >
                <span>{city.label}</span>
                <Image
                  src={`${assetLoader()}/icons/chevron_right_dark.svg`}
                  alt="right arrow"
                  width={20}
                  height={20}
                  className={styles.cityArrow}
                />
              </a>
            ))}
          </div>
        ))}
      </div>
    </UsedCarSeoSection>
  );
}